import { STORAGE_PREFIX } from './hooks.js';

// ─── Fortschritt & globale Keys ──────────────────────────────────────────
export function loadGlobal(key) {
  try { const raw = localStorage.getItem(STORAGE_PREFIX + "global." + key); return raw === null ? null : JSON.parse(raw); }
  catch (e) { return null; }
}
export function saveGlobal(key, val) {
  try { localStorage.setItem(STORAGE_PREFIX + "global." + key, JSON.stringify(val)); } catch (e) {}
}
export function loadKey(key) {
  try { const raw = localStorage.getItem(STORAGE_PREFIX + key); return raw === null ? null : JSON.parse(raw); }
  catch (e) { return null; }
}
// Muster "durchgearbeitet" = alle Modi: Unterscheiden alle Snippets beantwortet
// + in jedem Reagieren-Szenario eine Option gewaehlt. (Erkennen = geoeffnet, via visited.)
export function isDurchgearbeitet(id) {
  const p = PATTERNS[id];
  if (!p) return false;
  const snippetCount = Array.isArray(p.dialogSnippets) ? p.dialogSnippets.length : 0;
  const answered = loadKey(id + ".unterscheiden.answered");
  const answeredCount = Array.isArray(answered) ? answered.length : 0;
  if (answeredCount < snippetCount) return false;
  const scenarioCount = Array.isArray(p.scenarios) ? p.scenarios.length : 0;
  const chosen = loadKey(id + ".reagieren.chosen");
  const chosenCount = (chosen && typeof chosen === "object") ? Object.keys(chosen).length : 0;
  if (chosenCount < scenarioCount) return false;
  return true;
}
export function getPatternProgress(id) {
  const visited = loadGlobal("visited") || [];
  if (!visited.includes(id)) return "unberuehrt";
  return isDurchgearbeitet(id) ? "durchgearbeitet" : "angefangen";
}
// Zwei Meilenstein-Spuren: "begonnen" (geoeffnet, fruehe Motivation) + "durch" (durchgearbeitet)
export const MS_BEGONNEN = [1, 5];
export const MS_BEGONNEN_TEXT = {
  1: "Los geht's – dein erstes Muster ist offen.",
  5: "Fuenf Muster offen – die Neugier ist geweckt. Jetzt in die Tiefe!"
};
export const MS_DURCH = [1, 3, 5, 10, 22, 43];
export const MS_DURCH_TEXT = {
  1:  "Erstes Muster vertieft – stark! Erkannt, unterschieden, beantwortet.",
  3:  "Drei geschafft! Du durchschaust die Mechanik immer schneller.",
  5:  "Fuenf gemeistert – das sitzt. Weiter so!",
  10: "Zehn vertieft – beeindruckend. Ein Viertel des Katalogs gehoert dir.",
  22: "Zweiundzwanzig! Ueber die Haelfte mit voller Tiefe – starke Klarheit.",
  43: "Alle 43 gemeistert – Glueckwunsch! Du erkennst, unterscheidest und reagierst."
};

// Naechste Station im Pfad, der das aktuelle Muster enthaelt (erster Treffer)
export function getNextPathStation(patternId) {
  const curated = (typeof LERNPFADE !== "undefined" && Array.isArray(LERNPFADE)) ? LERNPFADE : [];
  const custom = loadGlobal("pfade");
  const all = curated.concat(Array.isArray(custom) ? custom : []);
  const path = all.find(p => p.stations.some(s => s.id === patternId));
  if (!path) return null;
  const idx = path.stations.findIndex(s => s.id === patternId);
  const next = path.stations[idx + 1];
  if (!next || !PATTERNS[next.id]) return null;
  return { id: next.id, mode: next.mode || "erkennen", title: PATTERNS[next.id].title };
}

// ─── Hash-Routing (Browser-Zurueck + Deep-Links) ──────────────────────────
export function buildHash(view, patternId, mode, meinTab) {
  if (view === "about") return "#ueber";
  if (view === "mein")  return "#mein/" + (meinTab || "erkundung");
  if (view === "pattern" && patternId) return "#muster/" + patternId + "/" + mode;
  return "";
}
export function parseHash() {
  const raw = window.location.hash.replace(/^#/, "");
  if (!raw) return { view: "landing", patternId: null, mode: "erkennen" };
  const parts = raw.split("/");
  if (parts[0] === "ueber") return { view: "about", patternId: null, mode: "erkennen" };
  if (parts[0] === "mein") {
    const t = ["erkundung", "lernpfade", "landkarte"].includes(parts[1]) ? parts[1] : "erkundung";
    return { view: "mein", patternId: null, mode: "erkennen", meinTab: t };
  }
  if (parts[0] === "muster" && parts[1] && PATTERNS[parts[1]]) {
    const m = ["erkennen", "unterscheiden", "reagieren"].includes(parts[2]) ? parts[2] : "erkennen";
    return { view: "pattern", patternId: parts[1], mode: m };
  }
  return { view: "landing", patternId: null, mode: "erkennen" };
}

// ─── Verwechslungsnetz (Landkarte) ────────────────────────────────────────
export var IS_TOUCH = (typeof navigator !== "undefined" && navigator.maxTouchPoints > 0) || ("ontouchstart" in window);
// Kanten: similarTo + dialogSnippets.otherPattern (undirected, dedupliziert)
export function buildVerwechslungsEdges() {
  var set = {};
  Object.keys(PATTERNS).forEach(function(id) {
    var p = PATTERNS[id];
    (p.similarTo || []).forEach(function(ref) { if (PATTERNS[ref] && ref !== id) set[[id, ref].sort().join("|")] = 1; });
    (p.dialogSnippets || []).forEach(function(s) { if (s && s.isThis === false && s.otherPattern && PATTERNS[s.otherPattern] && s.otherPattern !== id) set[[id, s.otherPattern].sort().join("|")] = 1; });
  });
  return Object.keys(set).map(function(k) { return k.split("|"); });
}
export var LK_ZONES = {
  ablenkung:       { label: "Ablenkung",           cx: 228, cy: 195, r: 118 },
  verschiebung:    { label: "Verschiebung",         cx: 652, cy: 188, r: 106 },
  destabilisierung:{ label: "Destabilisierung",     cx: 228, cy: 520, r: 70 },
  bindung:         { label: "Bindung & Kontrolle",  cx: 652, cy: 520, r: 82 }
};
